import React, { useState } from "react";
import {
  List,
  ListItem,
  Container,
  useTheme,
  useMediaQuery
} from "@mui/material";
import Box from '@mui/material/Box';
import PurpleButton from '../common/buttonTheme';
import TodoDrawer from './editToDoDrawer';
import ToDoItem from './toDoItem';
import SearchComponent from "./filtertodos";
import FullScreenDialog from "./FullScreenDialogue";
import ConfirmDialogue from "./confirmDialogue";
import AssistantDialog from './assistant';

function ToDoListPresenter({
  handleNewToDo,
  todos,
  drawerOpen,
  onTitleChange,
  onDescriptionChange,
  onListNameChange,
  saveTodo,
  onDelete,
  title,
  description,
  listName,
  dateTimeToDoToDo,
  onDateToDoToDoChange,
  closeDrawer,
  isEdited,
  changeorder,
  handleDone,
  handleEdit,
  notes,
  onNotesChange,
  percentDone,
  setPercentDone,
  handleFilter,
  deleteDialogueOpen,
  handleDecision,
  handleAssistantResponse,
  assistantSteps,
  clearAssistant,
  listNames,
  isToDunsPage,
  editedId,
  responders,
  conversation,
  handleConversationUpdate,
  isDone,
  handleDoneFromDrawer
}) {

  const [openView, setOpenView] = useState(false);
  const [viewToDo, setViewToDo] = useState({});
  const [viewAssistant, setviewAssistant] = useState(false);
  const [switchTodoview, setswitchTodoview] = useState("View Today's Todos");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleTodoview = () => {
    if (switchTodoview === "View Today's Todos") {
      handleFilter("Today's Todos")
      setswitchTodoview("View All Todos");
    } else {
      handleFilter("")
      setswitchTodoview("View Today's Todos");
    }
  }

  const isFieldTrue = (array, fieldName) => {
    return array.some(obj => obj[fieldName] === true);
  }

  const handleOpenView = (todo) => {
    setViewToDo(todo);
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
  };

  const handleOpenAssistant = (title,description) =>{
    setviewAssistant(true)
    handleAssistantResponse(title,description)
  };

  return (
    <Container
      component="main"
      maxWidth={false}
      sx={{
        textAlign: "center",
        marginTop: isMobile ? 8 : 12,
        width: "100%",
        maxWidth: "100%",
        padding: isMobile ? "0 8px" : "0 16px"
      }}
    >
      <Box sx={{ displayPrint: 'none', width: '100%', mb: 2 }}>
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
          mb: 1
        }}>
          <PurpleButton
            onClick={() => handleNewToDo()}
            variant="contained"
          >
            New todo +
          </PurpleButton>
          {!isToDunsPage &&
            <PurpleButton
              onClick={()=>{toggleTodoview()}}
              variant="contained"
            >
              {switchTodoview}
            </PurpleButton>
          }
        </Box>
        <SearchComponent {...{ handleFilter }} />
      </Box>

      {!isToDunsPage &&
        <List sx={{ width: '100%', padding: 0 }}>
          {todos.map((todo, index) => {
            if (todo.isDone) return null;
            return (
              <ListItem
                key={`LI` + todo.id}
                sx={{
                  width: '100%',
                  display: 'block',
                  padding: 0,
                  marginBottom: 2,
                  border: '1px solid lightgray'
                }}
              >
                <ToDoItem {...{ todo, todos, index, handleDone, handleEdit, onDelete, changeorder, handleOpenView, handleOpenAssistant}} />
              </ListItem>
            );
          })}
        </List>
      }

      {(isFieldTrue(todos, 'isDone')) && isToDunsPage &&
        <Box sx={{ width: '100%' }}>
          <Box sx={{ display: 'block', displayPrint: 'none', width: '100%' }}>
            {todos.map((todo, index) => {
              if (!todo.isDone) return null;
              return (
                <ListItem
                  key={`LI` + todo.id}
                  sx={{
                    width: '100%',
                    display: 'block',
                    padding: 0,
                    marginBottom: 2,
                    border: '1px solid lightgray'
                  }}
                >
                  <ToDoItem {...{ todo, todos, index, handleDone, handleEdit, onDelete, changeorder, handleOpenView }} />
                </ListItem>
              );
            })}
          </Box>
        </Box>
      }


      {/* Drawer for editing todos and saving new ones */}
      <TodoDrawer {...{
        drawerOpen,
        onTitleChange,
        onDescriptionChange,
        onListNameChange,
        saveTodo,
        onDelete,
        title,
        description,
        listName,
        dateTimeToDoToDo,
        onDateToDoToDoChange,
        closeDrawer,
        isEdited,
        notes,
        onNotesChange,
        percentDone,
        setPercentDone,
        listNames,
        todoId: editedId,
        responders,
        conversation,
        onConversationUpdate: handleConversationUpdate,
        isDone,
        onIsDoneChange: handleDoneFromDrawer
      }} />

      <FullScreenDialog  {...{ openView, handleCloseView, viewToDo }} />

      <ConfirmDialogue
        dialogueOpen={deleteDialogueOpen}
        handleDecision={handleDecision}
        displayTitle={"Delete Todo"}
        displayText={"Are you sure you want to delete this todoo?"}
      />
      
      <AssistantDialog {...{ viewAssistant, setviewAssistant , assistantSteps }} />
    
    </Container>
  );
}

export default ToDoListPresenter;